import React from 'react'

const PaymentMode = () => {
    return (
        <div>
            <h5>Select a payment method</h5>
            <div>
                <div>

                </div>
            </div>
        </div>
    )
}

export default PaymentMode
